import { Box, Card, CardContent, CardHeader, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { convertToURL } from "./downloadsHelpers";

export default function ProductCard({ title, path, images }) {
  let route = convertToURL(path)

  let navigate = useNavigate()

  return (
    <Card
      sx={{
        minWidth: { xs: 'fit-content', md: '31%' },
        cursor: 'pointer'
      }}
      onClick={() => {
        navigate(route)
      }}
    >
      {
        images.length > 0 &&
        <CardHeader
          title={title}
          sx={{
            padding: 1
          }}
        />
      }
      <CardContent
        sx={{
          padding: 1,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        {
          images.length > 0 ?
            <Box
              component={'img'}
              src={images[0].imageurl}
              sx={{
                height: '200px',
                aspectRatio: 'auto'
              }}
            >
            </Box>
            :
            <Box
              sx={{
                height: '248px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography
                variant="h4"
              >
                {title}
              </Typography>
            </Box>
        }
      </CardContent>
    </Card>
  )
}